import { render } from "./QuestionTab.vue?vue&type=template&id=12e87ecd&scoped=true"
import script from "./QuestionTab.vue?vue&type=script&lang=js"
export * from "./QuestionTab.vue?vue&type=script&lang=js"

import "./QuestionTab.vue?vue&type=style&index=0&id=12e87ecd&lang=sass&scoped=true"

import exportComponent from "/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e87ecd"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QSeparator,QList,QItem,QItemSection,QIcon,QItemLabel});qInstall(script, 'directives', {Ripple});
